import React from 'react';
import { useRecordContext, useTranslate } from 'react-admin';

import ChipField, { getChipColors } from '../../common/fields/ChipField';


const StatusField = ({ source = 'status', size = 'small', ...props }) => {
    const record = useRecordContext(props);
    const translate = useTranslate();

    if (!record) {
        return null;
    }
    const status = record[source];
    let sx = {};
    switch (status) {
        case 'active':
        case 'done':
            sx = getChipColors('green');
            break;
        case 'paused':
            sx = getChipColors('orange');
            break;
        case 'maintenance':
            sx = getChipColors('blue');
            break;
        case 'cancelled':
        case 'late':
        case 'blocked':
            sx = getChipColors('red');
            break;
        default:
            break;
    }

    if (!status) {
        return null;
    }

    const statuses = {
        'active': translate('Active'),
        'paused': translate('Paused'),
        'maintenance': translate('Maintenance'),
        'done': translate('Done'),
        'cancelled': translate('Cancelled'),
        'late': translate('Late'),
        'blocked': translate('Blocked'),
    };

    return (
        <ChipField {...props} size={size} source={status} record={statuses} sx={sx} />
    );
};

export default StatusField;
